import { Box, Checkbox, Column, Input, Row } from '@amzn/meridian';

type RefTagInputProps = {
  isAutoGenEnabled: boolean;
  onAutoGenChange: (checked: boolean) => void;
  onChange: (value: string) => void;
  value: string;
};

export const RefTagInput = ({ isAutoGenEnabled, onAutoGenChange, onChange, value }: RefTagInputProps) => (
  <Row
    alignmentVertical="bottom"
    widths={[
      'fill',
      'fit',
    ]}
  >
    <Column>
      <Input disabled={isAutoGenEnabled} label="Ref tag" onChange={onChange} value={value} />
    </Column>
    <Column>
      <Box>
        <Checkbox checked={isAutoGenEnabled} onChange={onAutoGenChange} size="small">
          Auto-generate
        </Checkbox>
      </Box>
    </Column>
  </Row>
);
